module.exports = __webpack_public_path__ + "static/media/s.a6a254ae.svg";